import React from 'react';

import mooreIsBetterSiteHeader from '../css/images/moore_is_better_july_2020_header.png';

const MainHeader = props => (
    <div className={props.className}>
      <img src={mooreIsBetterSiteHeader} alt="Every Organization has a Healthcare Division. How's your's running?" />
    </div>
);

export default MainHeader;



// WEBPACK FOOTER //
// ./src/components/MainHeader.js